import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CoreAuthCookiesService } from './core-auth.cookies.service';
import { CoreAuthConfig } from './core-auth.models';
import { CORE_AUTH_CONFIG } from './core-auth.tokens';

@Injectable({
  providedIn: 'root',
})
export class CoreAuthGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly cookiesService: CoreAuthCookiesService,
    @Inject(CORE_AUTH_CONFIG) private readonly config: CoreAuthConfig,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (this.cookiesService.isSessionAvailable()) {
      return true;
    }

    this.router.navigate([this.config.session.loginRoute || '/login']);
    return false;
  }
}
